import { ChangeEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TextField, MenuItem, Select, Button, FormControlLabel, Box, Tab, Tabs, Checkbox, CardMedia, IconButton, Input } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

type DayOfWeek =
  | "Monday"
  | "Tuesday"
  | "Wednesday"
  | "Thursday"
  | "Friday"
  | "Saturday"
  | "Sunday";

interface Availability {
  enabled: boolean;
  start: string;
  end: string;
}

const AddStore = () => {

  const navigate = useNavigate();
  const [status, setStatus] = useState("default");
  const [region, setRegion] = useState("default");
  const [valueTabs, setValueTabs] = useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");

  const [availability, setAvailability] = useState<Record<DayOfWeek, Availability>>({
    Monday: { enabled: true, start: "09:00", end: "18:00" },
    Tuesday: { enabled: true, start: "09:00", end: "18:00" },
    Wednesday: { enabled: true, start: "09:00", end: "18:00" },
    Thursday: { enabled: true, start: "09:00", end: "18:00" },
    Friday: { enabled: true, start: "09:00", end: "18:00" },
    Saturday: { enabled: false, start: "09:00", end: "18:00" },
    Sunday: { enabled: false, start: "09:00", end: "18:00" },
  });

  const toggleAvailability = (day: DayOfWeek) => {
    setAvailability((prev) => ({
      ...prev,
      [day]: { ...prev[day], enabled: !prev[day].enabled },
    }));
  };

  const updateTime = (day: DayOfWeek, field: "start" | "end", value: string) => {
    setAvailability((prev) => ({
      ...prev,
      [day]: { ...prev[day], [field]: value },
    }));
  };

  return (
    <>
      <div className="main_title">
        <h1>Add Store</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - {" "}
          <button onClick={() => navigate("/manage-stores")}>Store Management</button> -
          Add Store
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="General Store Info" {...a11yProps(0)} />
              <Tab label="Store Availability" {...a11yProps(1)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <form className="form" action="">
          <CustomTabPanel value={valueTabs} index={0}>
            <div className="gap_p">
              {/* Store Image */}
              <div className="control_group w_100">
                <label htmlFor="store_image">Store Image</label>
                <div className="gap_p">
                  <div className="control_group w_33">
                    {image ? (
                      <div className="upload_image no_radius v2">
                        <div className="upload_image_holder">
                          <figure>
                            <CardMedia component="img" image={image} alt="Uploaded profile photo" />
                          </figure>
                          <IconButton
                            aria-label="Remove uploaded image"
                            onClick={() => {
                              setImage("");
                              setFileName("");
                            }}
                            size="small"
                          >
                            <CloseIcon />
                          </IconButton>
                        </div>
                      </div>
                    ) : (
                      <label className="upload_image no_radius v2" htmlFor="store_image">
                        <Input
                          sx={{ display: "none" }}
                          id="store_image"
                          type="file"
                          inputProps={{ accept: "image/png,image/jpeg" }}
                          onChange={(event: ChangeEvent<HTMLInputElement>) => {
                            const files = (event.target as HTMLInputElement).files;
                            if (files && files[0].type.includes("image")) {
                              setFileName(files[0].name);
                              setImage(URL.createObjectURL(files[0]));
                            } else {
                              setAlertType(0);
                              setShowAlert(true);
                              setAlertMessage("This field only accepts images.");
                            }
                          }}
                        />
                        <span className="upload_image_holder">
                          <figure className="add_img">
                            <img src="/static/images/placeholder.png" alt="placeholder" />
                            <span className="upload_img_icon">
                              <img src="/static/images/edit2_icon.svg" alt="Upload" />
                            </span>
                          </figure>
                        </span>
                      </label>
                    )}
                  </div>
                </div>
              </div>

              {/* Store Name */}
              <div className="control_group w_33">
                <label htmlFor="store_name">Store Name</label>
                <TextField id="store_name" placeholder="Enter Store Name" fullWidth hiddenLabel />
              </div>

              {/* Store Code */}
              <div className="control_group w_33">
                <label htmlFor="store_code">Store Code (Internal Reference)</label>
                <TextField id="store_code" placeholder="Enter Store Code" fullWidth hiddenLabel />
              </div>

              {/* Status */}
              <div className="control_group w_33">
                <label htmlFor="status">Status</label>
                <Select
                  id="status"
                  fullWidth
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <MenuItem disabled value="default">
                    Select Status
                  </MenuItem>
                  <MenuItem value="open">Open</MenuItem>
                  <MenuItem value="closed">Closed</MenuItem>
                </Select>
              </div>

              {/* Address */}
              <div className="control_group w_66">
                <label htmlFor="store_address">Address</label>
                <TextField
                  id="store_address"
                  placeholder="Enter Store Address"
                  fullWidth
                  hiddenLabel
                />
              </div>

              {/* Region/City */}
              <div className="control_group w_33">
                <label htmlFor="region">Region / City</label>
                <Select
                  id="region"
                  fullWidth
                  value={region}
                  onChange={(e) => setRegion(e.target.value)}
                >
                  <MenuItem disabled value="default">
                    Select Region / City
                  </MenuItem>
                  <MenuItem value="newyork">New York</MenuItem>
                  <MenuItem value="london">London</MenuItem>
                  <MenuItem value="delhi">Delhi</MenuItem>
                </Select>
              </div>

              {/* Google Map Embed */}
              <div className="control_group w_100">
                <label htmlFor="map">Map Location</label>
                <iframe
                  title="map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3559.9533272900557!2d80.98112951501063!3d26.84669338315635!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399be2a68c3f2a0f%3A0x9b63c82ac1f3a60!2sLucknow%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1616580979832!5m2!1sen!2sin"
                  width="100%"
                  height="250"
                  style={{ border: 0, borderRadius: '10px', display: 'flex', overflow: 'hidden' }}
                  allowFullScreen
                  loading="lazy"
                ></iframe>
              </div>

              {/* Order Online Link */}
              <div className="control_group w_50">
                <label htmlFor="order_link">Order Online Link (Optional)</label>
                <TextField
                  id="order_link"
                  placeholder="Enter Online Order URL"
                  fullWidth
                  hiddenLabel
                />
              </div>

              {/* Store Manager Contact */}
              <div className="control_group w_50">
                <label htmlFor="manager_contact">Store Manager Contact (Optional)</label>
                <TextField
                  id="manager_contact"
                  placeholder="Enter Store Manager Contact"
                  fullWidth
                  hiddenLabel
                />
              </div>
            </div>
            <div className="form_btn">
              <Button className="btn btn_primary" onClick={() => setValueTabs(1)}>Continue</Button>
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={1}>
            <div className="section_title">
              <h2>Weekly Availability</h2>
            </div>
            {/* Availability Toggle */}
            {(Object.keys(availability) as DayOfWeek[]).map((day) => (
              <div className="availability_item">
                <div className="gap_p aic">
                  <div className="control_group w_33">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={availability[day].enabled}
                          onChange={() => toggleAvailability(day)}
                        />
                      }
                      label={day}
                    />
                  </div>
                  {
                    availability[day].enabled && (
                      <div className="control_group w_66">
                        <div className="gap_p">
                          <div className="control_group flex w_50">
                            <label htmlFor="startTime">Start Time</label>
                            <TextField
                              type="time"
                              id="startTime"
                              value={availability[day].start}
                              onChange={(e) => updateTime(day, "start", e.target.value)}
                              InputLabelProps={{ shrink: true }}
                              size="small"
                            />
                          </div>
                          <div className="control_group flex w_50">
                            <label htmlFor="endTime">End Time</label>
                            <TextField
                              type="time"
                              id="endTime"
                              value={availability[day].end}
                              onChange={(e) => updateTime(day, "end", e.target.value)}
                              InputLabelProps={{ shrink: true }}
                              size="small"
                            />
                          </div>
                        </div>
                      </div>
                    )
                  }
                </div>
              </div>
            ))}
            <div className="form_btn">
              <Button className="btn btn_primary" onClick={() => navigate('/manage-stores')}>Submit</Button>
            </div>
          </CustomTabPanel>
        </form>
      </div>
    </>
  );
};

export default AddStore;
